import SyncIcon from "@mui/icons-material/Sync";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Divider,
  Grid2 as Grid,
  Stack,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { useTranslation } from "react-i18next";
import ColumnMenu from "./ColumnsMenu";

export default function CustomGridToolbar(props) {
  const { title, columnUniqueKey, topButtons, excelExport, excelFetching } =
    props;
  const { t } = useTranslation();

  return (
    <>
      <Grid container size={{ xs: 12 }} sx={{ width: "100%" }}>
        <Grid
          container
          justifyContent="space-between"
          spacing={1}
          size={{ xs: 12 }}
          sx={{
            color: "#2198e3",
            pb: 1,
          }}
        >
          {title && (
            <Grid size={{ xs: 6 }}>
              <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
                <Typography
                  component="span"
                  variant="h5"
                  sx={{ mr: 2, fontWeight: "500" }}
                  className="card-title"
                >
                  {title}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Divider />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Stack direction="row" spacing={1} display="flex">
            {!!props.addNew && (
              <Button
                title={props.addNew.text}
                variant="contained"
                color="primary"
                onClick={props.addNew}
              >
                {props.addNew.text}
              </Button>
            )}
            {topButtons}
            <LoadingButton
              variant="contained"
              onClick={excelExport}
              sx={{ backgroundColor: "green" }}
              disabled={excelFetching}
              loading={excelFetching}
            >
              {t("excel")}
            </LoadingButton>
            <ColumnMenu storageKey={columnUniqueKey} />
            <Box flexGrow={1} />
            <IconButton onClick={props.reFetch} disabled={props.notFetch}>
              <SyncIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
